import { render, staticRenderFns } from "./the-bind-equ.vue?vue&type=template&id=f420986a&scoped=true&"
import script from "./the-bind-equ.vue?vue&type=script&lang=js&"
export * from "./the-bind-equ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f420986a",
  null
  
)

export default component.exports